<script setup lang="ts">
</script>

<template>
  <!-- Rendered inside the shell's <main>, so it centres in most of the viewport, not all of it. -->
  <div class="flex min-h-[70svh] flex-col items-center justify-center py-16 text-center">
    <span class="flex size-20 items-center justify-center rounded-full bg-primary/10 ring-8 ring-primary/5">
      <UIcon
        name="i-lucide-compass"
        class="size-9 text-primary"
      />
    </span>
    <h1 class="mt-7 text-2xl font-bold text-highlighted">
      Страница не найдена
    </h1>
    <p class="mt-2 max-w-sm text-base leading-relaxed text-toned text-balance">
      К сожалению, по этому адресу ничего нет.
    </p>
    <UButton
      :to="{ name: 'Home' }"
      size="lg"
      color="primary"
      icon="i-lucide-house"
      label="На главную"
      class="mt-8"
    />
  </div>
</template>
